import { FC, RefObject } from 'react';

import { ModalFormTableOfContents } from '@/shared';

import { oauthApplicationCreationSteps, OAuthApplicationFormSectionKey } from '../../steps';

interface OAuthApplicationFormAnchorsProps {
    availableSteps: Record<OAuthApplicationFormSectionKey, boolean>;
    scrollContainerRef: RefObject<HTMLDivElement | null>;
}

const OAuthApplicationFormAnchors: FC<OAuthApplicationFormAnchorsProps> = ({ availableSteps, scrollContainerRef }) => (
    <ModalFormTableOfContents
        items={oauthApplicationCreationSteps.map((step) => {
            const StepIcon = step.icon;

            return {
                disabled: !availableSteps[step.key],
                icon: <StepIcon />,
                key: step.key,
                label: step.label,
            };
        })}
        onSelect={(section) => {
            if (!scrollContainerRef.current) {
                return;
            }

            const step = oauthApplicationCreationSteps.find(({ key }) => key === section);

            if (step) {
                document.querySelector(`#${step.id}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }}
    />
);

export default OAuthApplicationFormAnchors;
